/* eslint-disable no-unused-vars */
import React from "react";

import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
// import TableFooter from "@material-ui/core/TableFooter";
// import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
// import TableSortLabel from "@material-ui/core/TableSortLabel";

import {
  FormattedDate,
  FormattedTime,
  // useIntl,
} from "react-intl";

import { DataSeries } from "./flotmodel";
import { MetaData } from "./MetaData";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // minWidth: 500,
      height: "100%",
    },
  })
);

interface EventTableProps {
  // nodes: any[];
  chartData: any[];
  allData: DataSeries[]; // series options (except yaxes?) => TODO allData must be included in metaData.options
  // data: any[];
  metaData: MetaData; // general plot options
  dataSeries: DataSeries[]; // actual data
  widgetStatic?: boolean;
  widgetTitle?: string;
}

function EventTableMui(props: EventTableProps) {
  const classes = useStyles(props);
  // const { match, location } = props;
  // const { nodes, startDate, endDate } = props;
  const {
    // nodes,
    chartData,
    // allData,
    // metaData /*, data*/,
    // dataSeries,
    // widgetStatic,
  } = props;

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // const handleChangePage = (
  //   event: React.MouseEvent<HTMLButtonElement> | null,
  //   newPage: number
  // ) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (
  //   event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  // const [pageSize , setPageSize] = useState(20);
  // const [pageSizes, setPageSizes] = useState([5, 10, 15]);
  // const [currentPage, setCurrentPage] = useState(0);
  // const [hiddenColumnNames, setHiddenColumnNames] = useState([
  //   "duration",
  //   "imageKey",
  //   "tagId",
  //   "eventId",
  //   "isAcknowledged",
  //   "iconFileName",
  // ] as string[]);
  // const [expandedRowIds, setExpandedRowIds] = useState([]);
  // const [columnWidths, setColumnWidths] = useState([] as TableColumnWidthInfo[]);

  // const nodeIds = nodes.map(node => node.id);

  const rows = chartData;

  const columns = [
    {
      id: "time",
      label: "Time",
      width: 200,
      format: ({ value }: any) => (
        <>
          {/* TODO Use row.sourceNode.timeZoneID for formatting! */}
          <FormattedDate
            value={value}
            year="numeric"
            month="2-digit"
            day="2-digit"
          />
          &nbsp;
          <FormattedTime value={value} />
        </>
      ),
    },
    // { id: "duration", label: "Duration", width: 128 },
    { id: "message", label: "Message", width: 800 },
    // { id: "imageKey", label: "Image Key", width: 128 },
    // { id: "tagId", label: "Tag Id", width: 128 },
    // { id: "eventId", label: "Event Id", width: 128 },
    // { id: "isAcknowledged", label: "Is Acknowledged", width: 128 },
    // { id: "iconFileName", label: "Icon File Name", width: 128 },
  ];

  // const page = /*(data.dataPoints && data.dataPoints.page) ||*/ {
  //   __typename: "Page",
  //   size: rows.length, // pageSize,
  //   totalElements: 0,
  //   totalPages: 0,
  //   number: currentPage,
  // };
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <TableContainer className={classes.container}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                // align={column.align}
                style={{ minWidth: column.width }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                No data
              </TableCell>
            </TableRow>
          )}
          {rows.map((row) => (
            <TableRow key={row.name}>
              {columns.map((column) => {
                const value = row[column.id];
                return (
                  <TableCell
                    key={column.id}
                    // align={column.align}
                    style={{ minWidth: column.width }}
                  >
                    {column.format ? column.format({ value, row }) : value}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={columns.length} />
            </TableRow>
          )}
        </TableBody>
        {/* <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25
              // , { label: 'All', value: -1 }
            ]}
              colSpan={2}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              // ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter> */}
      </Table>
    </TableContainer>
  );
}

export default EventTableMui;
